import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type FsPreparation = 'Both' | 'Consolidated' | 'Separate';

export interface DeiState {
  scheme: string;
  identifier: string;
  companyName?: string;
  start: string;
  end: string;
  prevStart?: string;
  prevEnd?: string;
  showComparatives: boolean;
  fsPreparation: FsPreparation;
  currency: string;   // e.g., iso4217:MYR
  decimals: string;   // e.g., -3
}

export interface FilingState {
  submissionType: 'FS';
  taxonomyPath: string;     // path to embedded JSON
  entrypointXsd: string;    // schemaRef href
  dei: DeiState | null;
}

const DEFAULT_STATE: FilingState = {
  submissionType: 'FS',
  taxonomyPath: 'assets/unified_taxonomy_mfrs_with_context_embedded.json',
  entrypointXsd: 'ssmt-fs-mfrs_2022-12-31_entry_point.xsd',
  dei: null
};

@Injectable({ providedIn: 'root' })
export class FilingStore {
  private _state = new BehaviorSubject<FilingState>(DEFAULT_STATE);
  state$ = this._state.asObservable();
  get snapshot(): FilingState { return this._state.value; }

  setSubmission(payload: Partial<Pick<FilingState, 'taxonomyPath'|'entrypointXsd'>>) {
    this._state.next({ ...this._state.value, ...payload });
  }
  setDei(dei: DeiState) { this._state.next({ ...this._state.value, dei }); }
  clear() { this._state.next(DEFAULT_STATE); }
}
